import Swiper from "swiper";

export const createComponentsCareer = () => {
	if (document.body.className.match(".career")) {
		let windowWidth = window.innerWidth;

		var swiperVerbs = new Swiper("#swiper-verbs .swiper-container", {
			// Optional parameters
			direction: "horizontal",
			loop: true,
			autoplay: 8000,
			autoplay: {
				disableOnInteraction: false
			},
			pagination: {
				el: "#swiper-verbs .swiper-pagination",
				type: "bullets",
				clickable: true
			}
		});

		var swiperGallery = new Swiper("#swiper-gallery .swiper-container", {
			loop: true,
			slidesPerView: 4,
			slidesPerGroup: 4,
			slidesPerColumn: 1,
			spaceBetween: 30,
			pagination: {
				el: "#swiper-gallery .swiper-pagination",
				clickable: true,
				type: "bullets"
			},
			breakpoints: {
				768: {
					simulateTouch: true,
					slidesPerView: 1,
					slidesPerGroup: 1,
					slidesPerColumn: 1,
					loop: true
				}
			}
		});

		if (windowWidth >= 768) {
			let activeLightbox = document.querySelectorAll(".active-lightbox");
			let lightboxCareer = document.querySelector("#lightbox_career");
			let lightboxCareerBg = document.querySelector("#lightbox_career .bg-lightbox");
			let lightboxCareerImg = document.querySelector("#lightbox_career img");
			let closeButton = document.querySelector("#close_lightbox");

			[].slice.call(activeLightbox).map(element => {
				element.addEventListener("click", function() {
					const imageGallery = element.querySelector("img");

					lightboxCareer.classList.remove("hide");
					lightboxCareerImg.src = imageGallery.src;
				});
			});

			lightboxCareerBg.addEventListener("click", function() {
				closeLightbox(lightboxCareer, lightboxCareerImg);
			});

			closeButton.addEventListener("click", function() {
				closeLightbox(lightboxCareer, lightboxCareerImg);
			});
		}
	}

	const closeLightbox = (lightboxCareer, lightboxCareerImg) => {
		lightboxCareer.classList.add("hide");
		lightboxCareerImg.src = "";
	};
};
